import { animate } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENTITY_NAMES } from 'src/app/modules/shared/constants/api-constants';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TasksService {

  private _tasksapiUrl = `${environment.travel}/tasks`
  constructor(
    private _http: HttpClient
  ) { }

  // Get all tasks
  getAllTasks(pageNumber: any, pageSize:any, token:any, searchValue:any, filters: any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._tasksapiUrl}`, paginationSettings);
  }

   // get tasks of user
   getTasksOfUser(userId:any,pageNumber:any,pageSize:any, token:any, searchValue:any, filters: any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._tasksapiUrl}/User/${userId}`, paginationSettings);
  }
  // get tasks of lead
  getAllTasksOfLead(leadId:any, pageNumber: any, pageSize:any, token:any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20
    }
    return this._http.post<any>(`${this._tasksapiUrl}/${ENTITY_NAMES.LEAD}/${leadId}`, paginationSettings)
  }

  // get single task
  getTask(id:any):Observable<any>{
    return this._http.get<any>(`${this._tasksapiUrl}/task/${id}`)
  }

  getTaskOfId(id:any):Observable<any>{
    return this._http.get<any>(`${this._tasksapiUrl}/GetTaskById/${id}`)
  }

  // Add task
  addTask(formData:any):Observable<any>{
    return this._http.post<any>(`${this._tasksapiUrl}/addtask`, formData)
  }

  //Edit task
  editTask(id:any, formData:any){
    return this._http.put<any>(`${this._tasksapiUrl}/task/${id}`, formData);
  }

  //delete task
  deleteTask(id:any):Observable<any>{
    return this._http.delete<any>(`${this._tasksapiUrl}/task/${id}`);
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${environment.travel}/updatetasks`, req)
  }
 
}
